<template>
  <div class="orderTalk">
    <el-button
      type="primary"
      :size="size"
      round
      @click="openDialog"
      v-if="!type"
      >{{ $t("makeInterview") }}</el-button
    >
    <span @click="openDialog" v-else><slot name="btn"></slot></span>
    <component
      ref="orderAgenda"
      :is="orderComponents"
      :orderVisible="orderVisible"
      @orderVisibleShow="orderVisibleShow"
      @dataChange="sendAgenda"
    ></component>
    <el-dialog
      :title="$t('tipsTitle')"
      :visible.sync="dialogVisible"
      width="400px"
      append-to-body
    >
      <span class="dialogTxt">{{ dialogTxt }}？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click="orderAgenda(orderVal)"
          size="small"
          :loading="orderLoading"
          >{{ $t("Confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import orderFreeDialog from "~/baseComponents/orderFreeDialog";
import orderDialog from "~bac/components/button/orderDialog";
import { secondFormat } from "~/basePlugins/filters";
export default {
  components: {
    orderFreeDialog: orderFreeDialog,
    orderDialog: orderDialog,
  },
  props: {
    position_apply_id: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: "mini",
    },
    in_companyId: {
      //接收面试公司id
      type: Number,
      default: null,
    },
    in_userId: {
      //接收面试公司负责人id
      // type: String || Number,
      // default: null,
    },
    position_id: {
      //职位id
      // type: Number || String,
      // default: null,
    },
    isApplicants: {
      //是否是应聘方
      type: Boolean,
      default: false,
    },
    invitationType: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      type: false,
      orderComponents: null,
      orderVisible: false,
      dialogVisible: false,
      orderLoading: false,
      orderVal: {},
      dialogTxt: "",
    };
  },
  methods: {
    orderVisibleShow(val) {
      if (val) {
        this.orderVisible = true;
      } else {
        this.orderVisible = false;
      }
    },
    openDialog() {
      this.orderVisible = true;
    },
    // 发送邀请
    async sendAgenda(val) {
      let params;
      if (this.orderComponents == "orderFreeDialog") {
        let obj = {
          meeting_status: 2,
          send_user_id: this.USER_INFO.id,
          in_user_id: this.in_userId,
          position_apply_id: this.position_apply_id,
          // in_company_id: this.in_companyId,
          // send_company_id: this.USER_INFO.company_id,
          // daily_source: 2,
          // position_apply_status: 2, //求职者预约2,招聘者预约3
          // apply_type: 2, //求职者预约1,招聘者预约2
          related_id: this.MEETING_ID,
          status: 1,
          position_id: this.position_id,
          chat_type: 2,
          invitation_type: 1,
          related_id: this.USER_INFO.company_id,
        };
        params = Object.assign(obj, val);
        // this.orderAgenda(params);
      } else {
        params = {
          meeting_status: 2,
          meeting_id: this.MEETING_ID,
          agenda_id: val.agenda_id,
          send_postscript: val.send_postscript,
          send_user_id: this.USER_INFO.id,
          in_user_id: this.in_userId,
          // in_company_id: this.in_companyId,
          // send_company_id: this.USER_INFO.company_id,
          // position_apply_status: 2, //求职者预约2,招聘者预约3
          // apply_type: 2, //求职者预约1,招聘者预约2
          room_type: 1,
          status: 1,
          position_id: this.position_id,
          chat_type: 1,
          user_id: this.USER_INFO.id, //投递者id
          invitation_type: 1,
        };
        // this.orderAgenda(obj);
      }
      if (this.isApplicants) {
        params.in_company_id = this.in_companyId;
        if (this.orderComponents == "orderFreeDialog") {
          params.daily_source = 1;
        }
        params.position_apply_status = 3;
        params.apply_type = 1;
        params.related_id = this.in_companyId;
        params.user_id = this.USER_INFO.id; //投递者id
      } else {
        params.send_company_id = this.USER_INFO.company_id;
        if (this.orderComponents == "orderFreeDialog") {
          params.daily_source = 2;
        }
        params.position_apply_status = 2;
        params.apply_type = 2;
        params.related_id = this.USER_INFO.company_id;
        params.user_id = this.in_userId; //投递者id
      }
      params.source = this.PJSource;
      params.invitation_type = this.invitationType;
      this.orderStatus(params);
    },
    // 预约状态
    async orderStatus(val) {
      this.orderVal = val;
      let params = {
        // meeting_id: this.MEETING_ID,
        meeting_status: val.meeting_status,
        invite_status: 1,
        user_id: this.USER_INFO.id,
        in_user_id: this.in_userId,
        position_id: val.position_id,
        related_id: this.USER_INFO.company_id,
        daily_source: 2,
      };
      if (this.isApplicants) {
        params.user_type = 1;
      } else {
        params.user_type = 2;
      }
      if (val.meeting_status == 2) {
        params.start_time = val.start_time;
        params.end_time = val.end_time;
      } else {
        params.agenda_id = val.agenda_id;
      }
      params.source = this.PJSource;
      let result = await this.$store.dispatch(
        "API_position/orderStatus",
        params
      );
      if (result.success) {
        if (JSON.stringify(result.data) == "{}") {
          this.orderAgenda(val);
        } else if (result.data.status) {
          // result.data.status = 6;
          switch (result.data.status) {
            case 1:
              this.dialogVisible = true;
              this.dialogTxt = this.$t("yuyue_message_1");
              break;
            case 3:
              this.dialogVisible = true;
              this.dialogTxt = this.$t("yuyue_message_10");
              break;
            case 5:
              this.dialogVisible = true;
              let timedate = `${secondFormat(
                result.data.info.start_time,
                "LLL"
              )}-${secondFormat(result.data.info.end_time, "T")}`;
              this.dialogTxt = `${this.$t(
                "yuyue_message_2"
              )} ${timedate} ${this.$t("yuyue_message_3")}`;
              break;
            case 6:
              this.dialogVisible = true;
              let timer = `${secondFormat(
                result.data.info.start_time,
                "LLL"
              )}-${secondFormat(result.data.info.end_time, "T")}`;
              this.dialogTxt = `${this.$t("yuyue_message_4")}${timer}${this.$t(
                "yuyue_message_5"
              )}`;
              break;
            case 7:
              this.dialogVisible = true;
              let timedates = `${secondFormat(
                result.data.info.start_time,
                "LLL"
              )}-${secondFormat(result.data.info.end_time, "T")}`;
              this.dialogTxt = `${this.$t(
                "yuyue_message_6"
              )}${timedates}${this.$t("yuyue_message_7")}`;
              break;
            case 8:
              this.dialogVisible = true;
              let timers = `${secondFormat(
                result.data.info.start_time,
                "LLL"
              )}-${secondFormat(result.data.info.end_time, "T")}`;
              this.dialogTxt = `${this.$t("yuyue_message_8")}${timers}${this.$t(
                "yuyue_message_9"
              )}`;
              break;
            case 9:
              this.$message.warning({
                message: this.$t("repeatTheBooking"),
                customClass: "zZindex",
              });
              break;
            default:
          }
          this.$refs.orderAgenda.loadingChange();
        } else {
        }
      }
    },
    // 面试预约
    async orderAgenda(params) {
      if (this.dialogVisible) {
        this.orderLoading = true;
      }
      params.stem_from = 2;
      params.source = this.PJSource;
      let result = await this.$store.dispatch(
        "API_position/jobAppointment",
        params
      );
      if (result.success && typeof result.info != "string") {
        this.$message.success({
          message: this.$t("sendSuccess"),
          customClass: "zZindex",
        });
        this.orderVisible = false;
        this.$emit("successChange");
        this.$refs.orderAgenda.loadingChange();
      } else {
        this.$message.error({
          message: this.$t("sendFail"),
          customClass: "zZindex",
        });
        this.$refs.orderAgenda.loadingChange();
      }
      if (this.dialogVisible) {
        this.dialogVisible = false;
        this.orderLoading = false;
      }
    },
  },
  mounted() {
    this.type = this.$scopedSlots.$hasNormal;
    if (this.MEETING_STATUS == 3 || !this.MEETING_ID) {
      this.orderComponents = "orderFreeDialog";
    } else {
      this.orderComponents = "orderDialog";
    }
    //   ref="agendaData"
    //         :orderVisible="orderVisible"
    //         @orderVisibleShow="orderVisibleShow"
  },
};
</script>
<style lang="less" scoped>
.orderTalk {
  display: inline-block;
}
.dialogTxt {
  font-size: 14px;
  line-height: 24px;
}
</style>
